import { render, staticRenderFns } from "./colorPanel.vue?vue&type=template&id=19c8e3c4&scoped=true"
import script from "./colorPanel.vue?vue&type=script&lang=js"
export * from "./colorPanel.vue?vue&type=script&lang=js"
import style0 from "./colorPanel.vue?vue&type=style&index=0&id=19c8e3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8e3c4",
  null
  
)

export default component.exports